module.exports = __webpack_public_path__ + "media/images/div_lens/relatable-img2-318cbf9f22049110a332b2d8d20f0e83.png";